import { CommonModule } from '@angular/common';
import { Component, Inject, inject, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, RouterModule } from '@angular/router';
import { AuthService, SimplePermissionService } from '@core/auth';
import { WA_WINDOW } from '@ng-web-apis/common';
import {
  FooterComponent,
  MenuItem,
  SideMenuComponent,
  SideNavLayoutComponent,
} from '@web/layout';
import notify from 'devextreme/ui/notify';
import { distinctUntilChanged, finalize } from 'rxjs';
import { menuItems, userMenuItems } from './app.navigation';
import { NewVersionNoticeComponent } from './components';
import { NewVersionService } from './services/new-version/new-version.service';

@Component({
  imports: [
    CommonModule,
    RouterModule,
    SideNavLayoutComponent,
    FooterComponent,
    SideMenuComponent,
    NewVersionNoticeComponent,
  ],
  selector: 'app-root',
  host: {
    '[class.new-version-available]': 'versions.newVersionAvailable()',
  },
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  public menuItems = menuItems;
  public userMenuItems = userMenuItems;
  public menuOpen = false;
  public readonly currentYear = new Date().getFullYear();
  protected readonly versions = inject(NewVersionService);

  /** Menüeinträge gefiltert nach den Rollen des angemeldeten Benutzers. */
  public get visibleMenuItems(): MenuItem[] {
    return this.menuItems.filter(
      (item) => !item.roles || this.permissions.hasOneOfRoles(item.roles)
    );
  }

  isAuth = toSignal(this.authService.isAuthenticated$, { initialValue: false });

  constructor(
    private readonly authService: AuthService,
    private readonly permissions: SimplePermissionService,
    private router: Router,
    @Inject(WA_WINDOW) private windowRef: Window
  ) {
    this.menuOpen = this.windowRef.innerWidth < 1280 ? false : false;
  }

  ngOnInit(): void {
    this.authService.isAuthenticated$
      .pipe(distinctUntilChanged())
      .subscribe(
        (isAuthenticated) =>
          (this.menuOpen =
            isAuthenticated &&
            (this.windowRef.innerWidth < 1280 ? false : false))
      );
  }

  public login({ email, password }: { email: string; password: string }) {
    this.authService.login(email, password).subscribe({
      error: (e) => {
        notify(e.error.message, 'error');
      },
    });
  }

  public menuItemClicked({ data }: MenuItem) {
    if (data && data.logout) {
      this.authService
        .logout()
        .pipe(finalize(() => this.router.navigateByUrl('/login')))
        .subscribe({
          error: (error) => notify(error.message, 'error'),
        });
    } else {
      this.menuOpen = this.windowRef.innerWidth < 1280 ? false : false;
    }
    // möglich das menü zu schließen etc
    // else {
    //   this.menuOpen = false;
    // }
  }
}
